import React from 'react';
import { createRoot } from 'react-dom/client';
import AppCRM from './AppCRM';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppCRM />
  </React.StrictMode>
);
